// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"131":"dde5daf8","312":"5723056f","568":"557e7a68","655":"636956ea","722":"87c9621f","868":"bbb6342b"}[chunkId] + ".css";
};